import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "react-query";
import { client, mapServerErrors } from "shared/helpers/client";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { useNavigate } from "react-router-dom";

interface ResetPasswordData {
  email: string;
}

export function useResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [serverErrors, setServerErrors] = React.useState({});
  const resetPasswordSchema = React.useMemo(() => {
    return yup.object().shape({
      email: yup.string().required(t("errors.required")).email(t("errors.invalid-email")),
    });
  }, [t]);
  const methods = useForm<ResetPasswordData>({
    resolver: yupResolver(resetPasswordSchema),
  });

  const { mutate: callResetPasswordServer, isLoading } = useMutation((email: string) =>
    client("/owner/forgetPassword", { params: { email },method:'POST' })
  );

  const resetPassword = (data: ResetPasswordData) => {
    callResetPasswordServer(data.email, {
      onSuccess({ response, error }) {
        if (response) return navigate("/password-sent");
        if (error) setServerErrors(mapServerErrors(error));
      },
    });
  };

  return { ...methods, isLoading, submit: methods.handleSubmit(resetPassword), serverErrors };
}
